import React from "react";
import Link, { navigateTo } from "gatsby-link";
import { AppBar, Toolbar } from "material-ui";
import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import Button from "material-ui/Button";
import Avatar from "material-ui/Avatar";
import Menu, { MenuItem } from "material-ui/Menu";

import firebase from "../lib/firebase";
import googleYoloManager from "../lib/googleYoloManager";
import Config from "../config";

const styles = {
  root: {
    width: "100%"
  },
  flex: {
    flex: 1
  }
};

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: firebase.auth().currentUser,
      showLogout: false
    };
  }

  componentWillMount() {
    this.unsubscribeAuthChangeListener = firebase
      .auth()
      .onAuthStateChanged(user => this.setState(user));
  }

  componentWillUnmount() {
    if (this.unsubscribeAuthChangeListener) {
      this.unsubscribeAuthChangeListener();
    }
  }

  logOutFromAccount = async () => {
    await googleYoloManager.logout();
    await firebase.auth().signOut();
    navigateTo("/");
  };

  render() {
    const { classes } = this.props;
    const { user } = this.state;
    return (
      <div className={classes.root}>
        {user && (
          <AppBar
            position="static"
            color={Config.production ? "secondary" : "primary"}
          >
            <Toolbar>
              <Typography type="title" color="inherit" className={classes.flex}>
                <Link
                  href="/admin"
                  to="/admin"
                  activeStyle={{ color: "white", textDecoration: "none" }}
                >
                  Cliffhanger Admin{" "}
                  {`${Config.production ? "PRODUCTION" : "DEVELOPMENT"}`}
                </Link>
              </Typography>
              <div>
                <Typography
                  style={{
                    color: "white",
                    verticalAlign: "middle",
                    display: "flex",
                    alignItems: "center"
                  }}
                >
                  {`${user.displayName}<${user.email}>`}
                  <Button
                    className={classes.button}
                    color="primary"
                    onClick={event => {
                      this.setState({
                        showLogout: true,
                        anchorEl: event.currentTarget
                      });
                    }}
                  >
                    <Avatar alt={user.displayName} src={user.photoURL} />
                  </Button>
                </Typography>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={this.state.showLogout}
                  onClose={() => {
                    this.setState({ showLogout: false });
                  }}
                >
                  <MenuItem onClick={this.logOutFromAccount}>Logout</MenuItem>
                </Menu>
              </div>
            </Toolbar>
          </AppBar>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(Header);



// WEBPACK FOOTER //
// ./src/layouts/header.js